import { useRef, useState } from 'react';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { TNavigationStackWithParams } from 'app/types';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';
import MeasurementFlow from "../components/activity/flow/MeasurementFlow"
import { ActivityName } from '../types';
import { ActivityType } from 'app/_modules/pathways/entities';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { FlowWizardHandle } from '@shared/components/form/FlowWizard';
import { dynamicTranslations, generateActivityTitleTranslation } from '@shared/utils/dynamicTranslation';

const MeasurementFlowScreen = () => {
    const route = useRoute<RouteProp<TNavigationStackWithParams<{
        activityName: ActivityName,
        activityId: string,
        initialStep?: number,
        isRemeasurement?: boolean,
        forceReset?: boolean,
        autoStartWebSocket?: boolean,
        hasDeviceError?: boolean
   }>, 'ActivitySubmit'>>();
    const navigation = useNavigation<NativeStackNavigationProp<TNavigationStackWithParams<undefined>>>();

    const activityName = route.params?.activityName;
    const activityId = route.params?.activityId;
    const isRemeasurement = route.params?.isRemeasurement || false;
    const forceReset = route.params?.forceReset || false;
    const autoStartWebSocket = route.params?.autoStartWebSocket || false;
    const hasDeviceError = route.params?.hasDeviceError || false;

    const initialStep = forceReset ? 0 : (route.params?.initialStep || 0);

    const wizardRef = useRef<FlowWizardHandle>(null);
    const [currentStep, setCurrentStep] = useState(initialStep);
    const [isWaitingForMeasurement, setIsWaitingForMeasurement] = useState(false);
    const { t } = dynamicTranslations();

    const handleHeaderBack = () => {
        if (isWaitingForMeasurement) {
            wizardRef.current?.cancelWebSocketListening();
            navigation.goBack();
        } else if (currentStep > 0) {
            wizardRef.current?.prev();
        } else {
            navigation.goBack();
        }
    }

    const headerTitle = !isWaitingForMeasurement && currentStep === 0 && activityName
        ? t(generateActivityTitleTranslation(activityName, ActivityType.PATHWAY_VITAL_PARAMETER, 'activity'))
        : undefined;

    return (
        <MainLayout
            navigation={handleHeaderBack}
            title={headerTitle}
            showBackText={!headerTitle && !isWaitingForMeasurement}
            backIcon={isWaitingForMeasurement ? 'close' : 'left'}
        >
                <MeasurementFlow
                    ref={wizardRef}
                    activityName={activityName}
                    activityId={activityId}
                    initialStep={initialStep}
                    forceReset={forceReset}
                    isRemeasurement={isRemeasurement}
                    autoStartWebSocket={autoStartWebSocket}
                    hasDeviceError={hasDeviceError}
                    onStepChange={(_, next) => setCurrentStep(next)}
                    onWaitingStateChange={setIsWaitingForMeasurement}
                />
        </MainLayout>
    );
};
export default MeasurementFlowScreen;